/**
 * About Euhomy 2 — 单版块连续滚动叙事
 * 桌面 / 移动共用同一套 scrub 时间线；发散图使用图片原始尺寸，移动端以 scatterDisplayScale 缩放
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 768px)';
  var DESKTOP_MQ = '(min-width: 769px)';
  var EASE = 'none';
  var TEXT_BRIGHT = 'rgba(10, 10, 10, 0.78)';

  function remPx(n) {
    if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.remPx === 'function') {
      return window.AboutEuhomy2.remPx(n);
    }
    var rem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rem'));
    return (Number(n) || 0) * (Number.isFinite(rem) && rem > 0 ? rem : 1);
  }

  function getCopyWidth(vw, isMobile) {
    var max = remPx(isMobile ? 520 : 520);
    return isMobile ? Math.min(vw * 0.55, max) : Math.min(vw * 0.88, max);
  }

  function getTitleWidth(vw, isMobile) {
    var max = remPx(isMobile ? 1100 : 720);
    return isMobile ? Math.min(vw * 0.94, max) : Math.min(vw * 0.94, max);
  }

  function copyLayoutProps(isMobile, vw) {
    var w = getCopyWidth(vw, isMobile);
    if (isMobile) {
      return {
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        xPercent: 0,
        x: 0,
        width: w,
        maxWidth: w,
      };
    }
    return {
      left: '50%',
      right: 'auto',
      marginLeft: 0,
      marginRight: 0,
      xPercent: -50,
      x: 0,
      width: w,
      maxWidth: w,
    };
  }

  function titleLayoutProps(isMobile, vw) {
    var w = getTitleWidth(vw, isMobile);
    return {
      width: w,
      maxWidth: w,
    };
  }

  function getPinScrollOptions(isMobile) {
    if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.getPinScrollOptions === 'function') {
      var shared = window.AboutEuhomy2.getPinScrollOptions(isMobile);
      if (!isMobile) return shared;
      /* 本版块移动端单独加长 scrub，关掉急停，减少触控抖动感 */
      return {
        scrub: 0.8,
        anticipatePin: shared.anticipatePin != null ? shared.anticipatePin : 1,
        fastScrollEnd: false,
      };
    }
    return isMobile
      ? { scrub: 0.8, anticipatePin: 1, fastScrollEnd: false }
      : { scrub: true, anticipatePin: 0, fastScrollEnd: false };
  }

  function getLayoutConfig(isMobile) {
    if (isMobile) {
      return {
        isMobile: true,
        /* 缩放节奏对齐 PC，仅略放大以补偿窄屏观感 */
        scatterDisplayScale: 1,
        scatterFinalScale: 0.62,
        photoStartScale: 0.54,
        titleEndTop: '50%',
        copyEndTop: null,
        titleCopyGap: remPx(60),
        alignToUsersIntro: true,
        titleEndScale: 0.48,
        /* 略拉长 pin 距离，进度变化更缓，触控更顺 */
        pinVhPerUnit: 8.4,
        birthPosMul: 0.55,
        birthScaleMul: 0.72,
        spreadMul: 1.28,
      };
    }

    return {
      isMobile: false,
      scatterDisplayScale: 1,
      scatterFinalScale: 0.72,
      photoStartScale: 0.52,
      titleEndTop: '34%',
      copyEndTop: null,
      titleCopyGap: remPx(60),
      alignToUsersIntro: false,
      titleEndScale: 0.5,
      pinVhPerUnit: 7.0,
      birthPosMul: 0.55,
      birthScaleMul: 0.72,
      spreadMul: 1.48,
    };
  }

  function getScatterScales(cfg) {
    var mul = cfg.scatterDisplayScale;
    return {
      start: cfg.photoStartScale * mul,
      final: cfg.scatterFinalScale * mul,
    };
  }

  function getCenter(vw, vh) {
    return { cx: vw * 0.5, cy: vh * 0.5 };
  }

  /* 标题 + 文案安全区（图片起点在其下方，外扩时避开压字） */
  function getTextSafeZone(vw, vh, cfg) {
    var isMobile = !!cfg.isMobile;
    var copyW = getCopyWidth(vw, isMobile);
    var titleH = isMobile ? Math.min(remPx(72), vh * 0.09) : Math.min(remPx(96), vh * 0.1);
    var copyH = isMobile ? Math.min(remPx(160), vh * 0.22) : Math.min(remPx(300), vh * 0.34);
    var gap = cfg.titleCopyGap || remPx(60);
    var halfW = copyW * 0.5 + (isMobile ? remPx(8) : remPx(48));
    var halfH = (titleH + gap + copyH) * 0.5 + (isMobile ? remPx(6) : remPx(36));
    var cx = vw * 0.5;
    var cy = isMobile ? vh * 0.44 : vh * 0.44;
    return { cx: cx, cy: cy, halfW: halfW, halfH: halfH };
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  /*
    初始槽位：环绕标题/文案四周（PC / 移动共用，体验一致）
    lp/tp = 视口宽高百分比（中心点）
  */
  var START_SLOTS = [
    { lp: 18, tp: 22 },
    { lp: 32, tp: 34 },
    { lp: 68, tp: 34 },
    { lp: 82, tp: 24 },
    { lp: 14, tp: 48 },
    { lp: 86, tp: 50 },
    { lp: 24, tp: 66 },
    { lp: 50, tp: 70 },
    { lp: 72, tp: 62 },
    { lp: 84, tp: 72 },
  ];

  /* 移动端终态：更分散，拉大间距，避免挤在中带 */
  var MOBILE_END_SLOTS = [
    { lp: 12, tp: 10 },
    { lp: 52, tp: 8 },
    { lp: 88, tp: 14 },
    { lp: 8, tp: 30 },
    { lp: 40, tp: 26 },
    { lp: 90, tp: 36 },
    { lp: 16, tp: 52 },
    { lp: 70, tp: 48 },
    { lp: 8, tp: 76 },
    { lp: 48, tp: 82 },
    { lp: 86, tp: 72 },
    { lp: 28, tp: 18 },
  ];

  function estimatePhotoSize(vw, cfg) {
    if (cfg.isMobile) return Math.min(vw * 0.48, 188);
    return remPx(280);
  }

  function slotToOffset(slot, vw, vh, cfg) {
    var page = getCenter(vw, vh);
    var edge = cfg.isMobile ? Math.max(remPx(12), estimatePhotoSize(vw, cfg) * 0.28) : remPx(48);
    var x = clamp((vw * slot.lp) / 100, edge, vw - edge);
    var y = clamp((vh * slot.tp) / 100, edge, vh - edge);
    return { dx: x - page.cx, dy: y - page.cy, x: x, y: y };
  }

  /** 推开过近点；移动端终态可加大力度以拉开间距 */
  function separatePoints(points, minDist, edge, vw, vh, opts) {
    var i;
    var j;
    var iter;
    var cfg = opts || {};
    var iters = cfg.iters || 6;
    var strength = cfg.strength || 0.36;
    for (iter = 0; iter < iters; iter += 1) {
      for (i = 0; i < points.length; i += 1) {
        for (j = i + 1; j < points.length; j += 1) {
          var dx = points[j].x - points[i].x;
          var dy = points[j].y - points[i].y;
          var dist = Math.sqrt(dx * dx + dy * dy) || 0.01;
          if (dist >= minDist) continue;
          var push = (minDist - dist) * strength;
          var nx = dx / dist;
          var ny = dy / dist;
          points[i].x = clamp(points[i].x - nx * push, edge, vw - edge);
          points[i].y = clamp(points[i].y - ny * push, edge, vh - edge);
          points[j].x = clamp(points[j].x + nx * push, edge, vw - edge);
          points[j].y = clamp(points[j].y + ny * push, edge, vh - edge);
        }
      }
    }
  }

  function pushOutOfSafeZone(x, y, safe, edge, vw, vh, soft) {
    var dx = x - safe.cx;
    var dy = y - safe.cy;
    var nx = Math.abs(dx) / (safe.halfW + remPx(16));
    var ny = Math.abs(dy) / (safe.halfH + remPx(16));
    if (nx < 1 && ny < 1) {
      var push = (soft ? 1.08 : 1.22) / Math.max(nx, ny, soft ? 0.38 : 0.22);
      x = safe.cx + dx * push;
      y = safe.cy + dy * push;
      x = clamp(x, edge, vw - edge);
      y = clamp(y, edge, vh - edge);
    }
    return { x: x, y: y };
  }

  /** 批量计算起止位：终态可杂乱，位移轨迹统一沿中心→外放射线 */
  function buildPhotoMotion(count, vw, vh, cfg) {
    var page = getCenter(vw, vh);
    var safe = getTextSafeZone(vw, vh, cfg);
    var photoSize = estimatePhotoSize(vw, cfg);
    var edge = cfg.isMobile
      ? Math.max(remPx(10), photoSize * 0.22)
      : remPx(40);
    var spreadMul = cfg.spreadMul || 1.48;
    var birthPosMul = Math.min(0.72, Math.max(0.28, cfg.birthPosMul || 0.55));
    var minStart = photoSize * (cfg.isMobile ? 0.72 : 0.55);
    var minEnd = photoSize * (cfg.isMobile ? 1.12 : 0.62);
    var starts = [];
    var ends = [];
    var i;

    for (i = 0; i < count; i += 1) {
      var slot = START_SLOTS[i % START_SLOTS.length];
      var s = slotToOffset(slot, vw, vh, cfg);
      starts.push({ x: s.x, y: s.y });
    }
    separatePoints(starts, minStart, edge, vw, vh);

    for (i = 0; i < count; i += 1) {
      var ex;
      var ey;
      if (cfg.isMobile) {
        var endSlot = MOBILE_END_SLOTS[i % MOBILE_END_SLOTS.length];
        var jitterX = ((((i * 37) % 17) - 8) / 100) * vw;
        var jitterY = ((((i * 53) % 19) - 9) / 100) * vh;
        ex = clamp((vw * endSlot.lp) / 100 + jitterX, edge, vw - edge);
        ey = clamp((vh * endSlot.tp) / 100 + jitterY, edge, vh - edge);
      } else {
        var sx = starts[i].x;
        var sy = starts[i].y;
        ex = page.cx + (sx - page.cx) * spreadMul;
        ey = page.cy + (sy - page.cy) * spreadMul;
        ex = clamp(ex, edge, vw - edge);
        ey = clamp(ey, edge, vh - edge);
      }
      var cleared = pushOutOfSafeZone(ex, ey, safe, edge, vw, vh, cfg.isMobile);
      ends.push({ x: cleared.x, y: cleared.y });
    }

    if (cfg.isMobile) {
      /* 再沿中心外扩一截，拉开终态间距 */
      for (i = 0; i < ends.length; i += 1) {
        var rdx = ends[i].x - page.cx;
        var rdy = ends[i].y - page.cy;
        ends[i].x = clamp(page.cx + rdx * 1.18, edge, vw - edge);
        ends[i].y = clamp(page.cy + rdy * 1.18, edge, vh - edge);
      }
      separatePoints(ends, minEnd, edge, vw, vh, { iters: 10, strength: 0.5 });
    } else {
      separatePoints(ends, minEnd, edge, vw, vh);
    }

    return ends.map(function (end, idx) {
      var dx = end.x - page.cx;
      var dy = end.y - page.cy;
      var dist = Math.sqrt(dx * dx + dy * dy);
      /* 终态过近中心时给微偏移，保证能向外发散 */
      if (dist < remPx(24)) {
        var angle = (idx / Math.max(count, 1)) * Math.PI * 2;
        dx = Math.cos(angle) * remPx(80);
        dy = Math.sin(angle) * remPx(120);
        end.x = page.cx + dx;
        end.y = page.cy + dy;
      }
      return {
        birthX: dx * birthPosMul,
        birthY: dy * birthPosMul,
        fromX: dx * birthPosMul,
        fromY: dy * birthPosMul,
        toX: dx,
        toY: dy,
        rotation: cfg.isMobile ? ((((idx * 29) % 21) - 10) * 1.4) : 0,
      };
    });
  }

  function q(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qa(root, sel) {
    return root ? Array.from(root.querySelectorAll(sel)) : [];
  }

  function setReduced(root, reduced) {
    if (root) root.classList.toggle('is-reduced-motion', reduced);
  }

  function getInner(photo) {
    return q(photo, '[data-ae2-photo-inner]') || photo;
  }

  function initPhotos(gsap, photos, vw, vh, cfg) {
    var center = getCenter(vw, vh);
    var scales = getScatterScales(cfg);
    var count = photos.length;
    var birthScaleMul = cfg.birthScaleMul || 0.72;
    var motions = buildPhotoMotion(count, vw, vh, cfg);

    photos.forEach(function (photo, i) {
      var m = motions[i] || motions[0];
      photo.dataset.depth = String(0.35 + (i % 5) * 0.12);
      gsap.set(getInner(photo), { x: 0, y: 0, z: 0, force3D: true });
      gsap.set(photo, {
        transformOrigin: '50% 50%',
        left: center.cx,
        top: center.cy,
        xPercent: -50,
        yPercent: -50,
        x: m.birthX,
        y: m.birthY,
        rotation: 0,
        scale: scales.start * birthScaleMul,
        z: 0,
        opacity: 0,
        force3D: true,
        immediateRender: true,
      });
    });
  }

  function expandParaIntoLines(para) {
    var existing = qa(para, '[data-ae2-slogan-line]');
    if (existing.length) return existing;

    var lines = [];
    var chunks = [];
    var nodes = Array.prototype.slice.call(para.childNodes);
    var buf = '';

    function flushBuf() {
      var t = buf.replace(/\s+/g, ' ').trim();
      if (t) chunks.push(t);
      buf = '';
    }

    nodes.forEach(function (node) {
      if (node.nodeType === 3) {
        buf += node.textContent || '';
        return;
      }
      if (node.nodeType === 1 && String(node.nodeName).toLowerCase() === 'br') {
        flushBuf();
        return;
      }
      if (node.nodeType === 1) {
        buf += node.textContent || '';
      }
    });
    flushBuf();

    if (!chunks.length) {
      var fallback = (para.textContent || '').replace(/\s+/g, ' ').trim();
      if (fallback) chunks.push(fallback);
    }

    para.textContent = '';
    chunks.forEach(function (chunk) {
      var span = document.createElement('span');
      span.className = 'ae2-slogan__para-line';
      span.setAttribute('data-ae2-slogan-line', '');
      span.textContent = chunk;
      para.appendChild(span);
      lines.push(span);
    });
    return lines;
  }

  function collectRevealLines(paras) {
    var lines = [];
    paras.forEach(function (para) {
      lines.push.apply(lines, expandParaIntoLines(para));
    });
    return lines;
  }

  /**
   * 单段连续位移：由槽位附近浮现 → 外扩（动效与原先一致）
   * 移动端加大尺寸并做点分离，避免滚动堆叠
   */
  function syncPhotosSmooth(gsap, tl, photos, vw, vh, textStart, textEnd, cfg) {
    var scales = getScatterScales(cfg);
    var count = photos.length;
    var moveDur = Math.max(0.25, textEnd - textStart);
    var fadeIn = Math.min(0.36, Math.max(0.22, moveDur * 0.38));
    var stagger = count > 1
      ? Math.min(0.05, (fadeIn * 0.7) / Math.max(count - 1, 1))
      : 0;
    var birthScaleMul = cfg.birthScaleMul || 0.72;
    var motions = buildPhotoMotion(count, vw, vh, cfg);

    photos.forEach(function (photo, i) {
      var m = motions[i] || motions[0];
      var birthScale = scales.start * birthScaleMul;
      var appearAt = textStart + i * stagger;

      gsap.set(photo, {
        x: m.birthX,
        y: m.birthY,
        scale: birthScale,
        opacity: 0,
        rotation: 0,
        force3D: true,
      });

      tl.fromTo(photo, {
        opacity: 0,
      }, {
        opacity: 1,
        duration: fadeIn,
        ease: EASE,
        immediateRender: false,
      }, appearAt);

      tl.fromTo(photo, {
        x: m.birthX,
        y: m.birthY,
        scale: birthScale,
        rotation: 0,
      }, {
        x: m.toX,
        y: m.toY,
        scale: scales.final,
        rotation: m.rotation || 0,
        duration: moveDur,
        ease: EASE,
        immediateRender: false,
        force3D: true,
      }, textStart);
    });
  }

  function initScrollNarrative(ctx, root, isMobile) {
    var gsap = ctx.gsap;
    var cfg = getLayoutConfig(isMobile);
    var headerOffset = ctx.headerOffset || 0;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var pin = q(root, '[data-ae2-slogan-pin]');
    var blackFill = q(root, '[data-ae2-black-fill]');
    var videoWrap = q(root, '[data-ae2-video-wrap]');
    var titleWrap = q(root, '[data-ae2-title-wrap]');
    var introMark = q(root, '[data-ae2-intro-mark]');
    var heroTitle = q(root, '[data-ae2-slogan-title]');
    var sloganStage = q(root, '[data-ae2-slogan-stage]');
    var play = q(root, '[data-ae2-slogan-play]');
    var copy = q(root, '[data-ae2-slogan-copy]');
    var paras = qa(root, '[data-ae2-slogan-para]');
    var closing = q(root, '[data-ae2-slogan-closing]');
    var bodyParas = paras.filter(function (p) { return p !== closing; });
    var photos = qa(root, '[data-ae2-slogan-photo]');
    var intro = q(root, '[data-ae2-users-intro]');
    var eyebrow = q(root, '[data-ae2-users-eyebrow]');
    var usersHeadline = q(root, '[data-ae2-users-headline]');
    var lines = qa(root, '[data-ae2-users-line]');

    root.classList.toggle('is-mobile', isMobile);

    initPhotos(gsap, photos, vw, vh, cfg);

    gsap.set(titleWrap, Object.assign({ xPercent: -50, yPercent: -50, top: '50%', left: '50%', zIndex: 2 }, titleLayoutProps(isMobile, vw)));
    if (introMark) gsap.set(introMark, { opacity: 1, scale: 1 });
    if (heroTitle) gsap.set(heroTitle, { opacity: introMark ? 0 : 1 });
    gsap.set(blackFill, { scaleY: 0, transformOrigin: '50% 100%', opacity: 1 });
    gsap.set(videoWrap, { opacity: 1 });
    gsap.set(copy, Object.assign({ opacity: 0, top: '64%' }, copyLayoutProps(isMobile, vw)));
    gsap.set(paras, { opacity: 0, y: 16, color: TEXT_BRIGHT });
    if (play) gsap.set(play, { opacity: 1, y: 0 });

    var titleEndTop = cfg.titleEndTop;
    var copyEndTop = cfg.copyEndTop;
    if (cfg.alignToUsersIntro && titleWrap && heroTitle && pin && intro) {
      var usersStack = q(root, '[data-ae2-users-stack]');
      gsap.set(intro, { opacity: 1, visibility: 'hidden' });
      gsap.set([eyebrow, usersHeadline].filter(Boolean), { opacity: 1, y: 0 });
      if (usersStack) gsap.set(usersStack, { opacity: 1 });
      qa(root, '[data-ae2-users-line]').forEach(function (line) {
        gsap.set(line, { opacity: 1, y: 0 });
      });

      var pinRect = pin.getBoundingClientRect();
      var usersEls = [eyebrow, usersHeadline, usersStack].filter(Boolean);
      var usersTop = Math.min.apply(null, usersEls.map(function (el) {
        return el.getBoundingClientRect().top;
      })) - pinRect.top;
      var usersBottom = Math.max.apply(null, usersEls.map(function (el) {
        return el.getBoundingClientRect().bottom;
      })) - pinRect.top;
      var usersCenter = (usersTop + usersBottom) / 2;

      if (introMark) gsap.set(introMark, { opacity: 0 });
      gsap.set(heroTitle, { opacity: 1 });
      if (copy) {
        gsap.set(copy, Object.assign({ opacity: 1, visibility: 'hidden' }, copyLayoutProps(isMobile, vw)));
      }
      gsap.set(paras, { opacity: 1, y: 0 });
      gsap.set(titleWrap, Object.assign({
        top: usersCenter,
        scale: cfg.titleEndScale,
        xPercent: -50,
        yPercent: -50,
        left: '50%',
      }, titleLayoutProps(isMobile, vw)));

      var titleRect = heroTitle.getBoundingClientRect();
      var titleCenter = (titleRect.top + titleRect.bottom) / 2 - pinRect.top;
      var titleH = titleRect.height;
      var copyH = copy ? copy.getBoundingClientRect().height : 0;
      var gap = cfg.titleCopyGap || 60;
      var blockH = titleH + gap + copyH;
      var desiredTitleCenter = usersCenter - blockH / 2 + titleH / 2;
      var nextTop = usersCenter + (desiredTitleCenter - titleCenter);

      titleEndTop = Math.round(nextTop) + 'px';
      copyEndTop = Math.round(desiredTitleCenter + titleH / 2 + gap) + 'px';

      gsap.set(titleWrap, Object.assign({
        top: '50%',
        scale: 1,
        xPercent: -50,
        yPercent: -50,
        left: '50%',
        zIndex: 2,
      }, titleLayoutProps(isMobile, vw)));
      if (introMark) gsap.set(introMark, { opacity: 1 });
      gsap.set(heroTitle, { opacity: introMark ? 0 : 1 });
      if (copy) {
        gsap.set(copy, Object.assign({
          opacity: 0,
          visibility: 'visible',
          top: '64%',
        }, copyLayoutProps(isMobile, vw)));
      }
      gsap.set(paras, { opacity: 0, y: 16, color: TEXT_BRIGHT });
      gsap.set(intro, { opacity: 0, visibility: 'visible', pointerEvents: 'none' });
    } else if (cfg.titleCopyGap != null && titleWrap && heroTitle && pin) {
      if (introMark) gsap.set(introMark, { opacity: 0 });
      gsap.set(heroTitle, { opacity: 1 });
      gsap.set(titleWrap, Object.assign({
        top: cfg.titleEndTop,
        scale: cfg.titleEndScale,
        xPercent: -50,
        yPercent: -50,
        left: '50%',
      }, titleLayoutProps(isMobile, vw)));
      var pinBox = pin.getBoundingClientRect();
      var titleBox = heroTitle.getBoundingClientRect();
      copyEndTop = Math.round(titleBox.bottom - pinBox.top + cfg.titleCopyGap) + 'px';
      gsap.set(titleWrap, Object.assign({
        top: '50%',
        scale: 1,
        xPercent: -50,
        yPercent: -50,
        left: '50%',
        zIndex: 2,
      }, titleLayoutProps(isMobile, vw)));
      if (introMark) gsap.set(introMark, { opacity: 1 });
      gsap.set(heroTitle, { opacity: introMark ? 0 : 1 });
    }

    gsap.set(intro, { opacity: 0, pointerEvents: 'none' });
    gsap.set([eyebrow, usersHeadline], { opacity: 0, y: 20 });
    gsap.set(lines, { opacity: 0, y: 12 });

    var allParas = bodyParas.concat(closing ? [closing] : []);
    var revealLines = collectRevealLines(allParas);
    gsap.set(allParas, { opacity: 1, y: 0, color: TEXT_BRIGHT });
    gsap.set(revealLines, { opacity: 0, y: remPx(16), color: TEXT_BRIGHT });

    /*
      文案全流程（与 page.about-euhomy2.json 对应）：
      1) transition_text：Founded... / Euhomy is best known...
      2) stack_line：we empower... / From busy family...
      图片发散必须覆盖 1)+2) 全程
    */
    var heroStart = 0.035;
    var maskDur = 0.2;
    /* 遮罩上移约一半后再露出 About EUHOMY */
    var titleRevealAt = heroStart + maskDur * 0.5;
    var textStart = heroStart + 0.16;
    /* 移动端：步进略密、淡入略长并互相重叠，减少“一顿一顿”的段落感 */
    var lineStep = isMobile ? 0.1 : 0.11;
    var lineFade = isMobile ? 0.1 : 0.07;
    var lineStarts = revealLines.map(function (_, i) {
      return textStart + i * lineStep;
    });
    var copyPhaseEnd = (lineStarts.length ? lineStarts[lineStarts.length - 1] : textStart) + lineStep;

    var stackStep = isMobile ? 0.12 : 0.13;
    var stackFade = isMobile ? 0.11 : 0.08;
    var usersStart = copyPhaseEnd + 0.05;
    var stackBase = usersStart + 0.06;
    var stackStarts = lines.map(function (_, i) {
      return stackBase + i * stackStep;
    });
    var narrativeEnd = lines.length
      ? stackStarts[lines.length - 1] + stackStep
      : copyPhaseEnd;
    /* 文案全部出现后立刻结束，不再额外 hold，避免版块吸附空转 */
    var timelineEnd = narrativeEnd;

    var tl = gsap.timeline({ paused: true });
    var t = 0;

    if (play) tl.to(play, { opacity: 0, y: 12, duration: 0.03, ease: EASE }, t);
    t = heroStart;

    tl.to(blackFill, { scaleY: 1, duration: maskDur, ease: EASE }, heroStart);
    tl.to(videoWrap, { opacity: 0, duration: maskDur, ease: EASE }, heroStart);
    tl.to(titleWrap, Object.assign({
      top: titleEndTop,
      scale: cfg.titleEndScale,
      yPercent: -50,
      duration: 0.22,
      ease: EASE,
    }, titleLayoutProps(isMobile, vw)), heroStart);
    if (introMark) {
      tl.to(introMark, { opacity: 0, scale: 0.92, duration: 0.08, ease: EASE }, titleRevealAt);
    }
    if (heroTitle && introMark) {
      tl.to(heroTitle, { opacity: 1, duration: 0.1, ease: EASE }, titleRevealAt);
    } else if (heroTitle) {
      tl.fromTo(heroTitle, { opacity: 0 }, { opacity: 1, duration: 0.1, ease: EASE }, titleRevealAt);
    }
    tl.to(copy, Object.assign({
      opacity: 1,
      top: copyEndTop,
      duration: 0.12,
      ease: EASE,
    }, copyLayoutProps(isMobile, vw)), Math.max(heroStart + 0.1, titleRevealAt + 0.04));

    /* 图片：从首段 transition 到末段 stack_line 连续发散 */
    if (photos.length && (revealLines.length || lines.length)) {
      syncPhotosSmooth(gsap, tl, photos, vw, vh, textStart, narrativeEnd, cfg);
    }

    revealLines.forEach(function (lineEl, i) {
      tl.fromTo(lineEl, {
        opacity: 0,
        y: 14,
        color: TEXT_BRIGHT,
      }, {
        opacity: 1,
        y: 0,
        color: TEXT_BRIGHT,
        duration: lineFade,
        ease: EASE,
        immediateRender: false,
      }, lineStarts[i]);
    });

    tl.to(sloganStage, { opacity: 0, duration: 0.1, ease: EASE }, usersStart);
    tl.fromTo(intro, { opacity: 0 }, { opacity: 1, duration: 0.08, ease: EASE }, usersStart);
    if (eyebrow && (eyebrow.textContent || '').trim()) {
      tl.fromTo(eyebrow, { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 0.08, ease: EASE }, usersStart + 0.02);
    }
    if (usersHeadline && (usersHeadline.textContent || '').trim()) {
      tl.fromTo(usersHeadline, { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 0.09, ease: EASE }, usersStart + 0.05);
    }
    lines.forEach(function (line, i) {
      tl.fromTo(line, {
        opacity: 0,
        y: 12,
      }, {
        opacity: 1,
        y: 0,
        duration: stackFade,
        ease: EASE,
        immediateRender: false,
      }, stackStarts[i]);
    });

    tl.addLabel('usersIntroDone', timelineEnd);

    var pinLength = vh * timelineEnd * cfg.pinVhPerUnit;
    var pinScroll = getPinScrollOptions(isMobile);
    /* 移动端更长 scrub 跟手更顺；桌面保持轻微平滑 */
    var scrub = isMobile
      ? Math.max(0.7, Number(pinScroll.scrub) || 0.8)
      : (pinScroll.scrub === true ? 0.45 : Math.max(0.4, Number(pinScroll.scrub) || 0.45));

    var st = ctx.ScrollTrigger.create({
      trigger: root,
      start: 'top top+=' + headerOffset,
      end: '+=' + pinLength,
      pin: pin,
      scrub: scrub,
      animation: tl,
      anticipatePin: pinScroll.anticipatePin,
      fastScrollEnd: isMobile ? false : pinScroll.fastScrollEnd,
      invalidateOnRefresh: true,
    });

    return function () {
      root.classList.remove('is-mobile');
      st.kill();
      tl.kill();
    };
  }

  function init(ctx) {
    var root = document.querySelector('[data-ae2-slogan]');
    if (!root) return;
    setReduced(root, ctx.reducedMotion);
    if (ctx.reducedMotion) return;

    var mm = ctx.gsap.matchMedia();
    var cleanup = null;
    mm.add(DESKTOP_MQ, function () {
      cleanup = initScrollNarrative(ctx, root, false);
    });
    mm.add(MOBILE_MQ, function () {
      cleanup = initScrollNarrative(ctx, root, true);
    });
    return function () {
      if (cleanup) cleanup();
      mm.revert();
    };
  }

  if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.register === 'function') {
    window.AboutEuhomy2.register(init);
  }
})();
